import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoadIndicatorService } from './load-indicator.service';

/** IndicadorCargaInterceptorService */
@Injectable()
export class LoadIndicatorInterceptorService implements HttpInterceptor {
  /** IndicadorCargaInterceptorService */
  constructor(private sesion: LoadIndicatorService) {}

  /** Intercept */
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const evitarIndicadorCarga = this.sesion.avoidLoadIndicator(request.url);
    if (!evitarIndicadorCarga) {
      this.sesion.pendingRequests.next(
        this.sesion.pendingRequests.value + 1
      );
      console.log(request.url, this.sesion.pendingRequests.value);
    }

    return next.handle(request).pipe(
      finalize(() => {
        if (!evitarIndicadorCarga) {
          this.sesion.pendingRequests.next(
            this.sesion.pendingRequests.value - 1
          );
          console.log(
            'finalizando',
            request.url,
            this.sesion.pendingRequests.value
          );
        }
      })
    );
  }
}
